import { useEffect, useMemo, useState } from "react";
import { useSnapshot } from "valtio";
import { editorState } from "../../../../utils/editor";
import { accessCardState } from "../../../../stores/accessCardStore";
import {
  formatDateForPreview,
  formatTimeForPreview,
  getAccessCardDate,
} from "../../../../utils/dateUtils";
import { generateQRCodeSvgDataUri } from "../../../../utils/qrCodeSvg";
import { generateDefaultAccessCardHTML } from "../../../../templates/utils";
import TemplatePreview from "../../../../components/previews/TemplatePreview";

const AccessCardPreview = () => {
  const { accessCards, mainContent, brideFirstName, groomFirstName } = useSnapshot(editorState);
  const { selectedEvent, selectedEventType } = useSnapshot(accessCardState);

  // Get default values from editorState
  const textColor = accessCards?.textColor?.colorCode || "#000000";
  const backgroundColor = accessCards?.backgroundColor?.colorCode || "#FFFFFF";
  const backgroundType = accessCards?.backgroundCtx || "color";
  const eventDate = getAccessCardDate(accessCards?.date, mainContent?.date);
  const formattedDate = formatDateForPreview(eventDate);
  const formattedTime = formatTimeForPreview(eventDate);

  // Get the selected event's type for the event name
  const eventName = selectedEventType || "Reception";

  // Generate QR code SVG as data URI for preview (no actual QR generation needed)
  const qrCodeSvgDataUri = useMemo(() => {
    return generateQRCodeSvgDataUri(textColor);
  }, [textColor]);

  // Generate HTML template with current data
  const [previewHTML, setPreviewHTML] = useState<string>("");

  useEffect(() => {
    generateDefaultAccessCardHTML({
      brideName: brideFirstName || "BRIDE",
      groomName: groomFirstName || "GROOM",
      eventName: eventName,
      showEventName: accessCards?.showEventName ?? true,
      date: formattedDate,
      time: formattedTime,
      venue: accessCards?.address || "",
      guestName: "YOUR GUEST",
      showGuestName: accessCards?.showGuestName ?? false,
      showAdmitsOneOnly: accessCards?.showAdmitsOneOnly ?? false,
      textColor: textColor,
      backgroundColor: backgroundColor,
      backgroundImage: accessCards?.backgroundImage,
      overlayColor: accessCards?.overlayColor?.colorCode || "#000000",
      overlayOpacity: accessCards?.overlayOpacity ?? 0.7,
      backgroundType,
      qrCode: qrCodeSvgDataUri, // Use SVG data URI for preview
      qrPosition: accessCards?.qrPosition || "center",
      qrSize: accessCards?.qrSize || 100,
    }).then(setPreviewHTML);
  }, [
    accessCards?.address,
    accessCards?.backgroundImage,
    accessCards?.overlayColor?.colorCode,
    accessCards?.overlayOpacity,
    accessCards?.qrPosition,
    accessCards?.qrSize,
    accessCards?.showGuestName,
    accessCards?.showAdmitsOneOnly,
    accessCards?.showEventName,
    backgroundColor,
    backgroundType,
    eventDate,
    eventName,
    formattedDate,
    formattedTime,
    qrCodeSvgDataUri,
    selectedEvent,
    selectedEventType,
    textColor,
    brideFirstName,
    groomFirstName,
  ]);

  return (
    <div style={{
      width: "100%",
      height: "80%",
      maxWidth: "398px",
      maxHeight: "600px",
      minHeight: "450px",
      marginTop: "32px"
    }}>
      <TemplatePreview htmlContent={previewHTML} />
    </div>
  );
};

export default AccessCardPreview;
